export default () => {
  let lastId,
      topMenu = $(".product-card__nav"),
      topMenuHeight = topMenu.outerHeight() + 15,
      menuItems = topMenu.find("a"),

  scrollItems = menuItems.map(function scrollItems() {
    const item = $($(this).attr("href"));
    if (item.length) { 
      return item; 
    }
  });

  $(window).scroll(function () {
    const fromTop = $(this).scrollTop()+topMenuHeight;
    let cur = scrollItems.map(function() {
      if ($(this).offset().top < fromTop)
        return this;
    });
    cur = cur[cur.length-1];
    const id = cur && cur.length ? cur[0].id : "";
    if (lastId !== id) {
      lastId = id;
      menuItems.removeClass("active").filter(`[href='#${id}']`).addClass("active");
    }                   
  });
}



// WEBPACK FOOTER //
// app/scripts/components/active-nav.js